import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "../../components/Button";
import { PrincipalButton } from "../../components/PrincipalButton";
import {
  HiOutlineCheck,
  HiOutlinePencil,
  HiOutlinePlus,
  HiOutlineTrash,
  HiOutlineXMark,
  HiPlus,
} from "react-icons/hi2";

import {
  GridToolbarContainer,
  GridToolbarQuickFilter,
} from "@mui/x-data-grid-pro";
import { DataGridBase } from "../../components/DataGrid/DataGridBase";
import ClickAwayListener from "@mui/material/ClickAwayListener";
import { SlOptionsVertical } from "react-icons/sl";
import Modal from "../../components/Modal";
import api from "../../api/api";
import { Select } from "../../components/Select";
import { toast } from "react-toastify";
import { MdEdit, MdContentCopy } from "react-icons/md";
import { Input } from "../../components/Input";
import { CustomCheckbox } from "../../components/Checkbox";
import moment from "moment";
import { knowAcces } from "../../utils/utils";

export const SenzaIncarico = ({ screenSize, f24, dataF24 }) => {
  const [self24, setSelF24] = useState(null);
  const [referenti_esterni, setReferentiEsterni] = useState([]);
  const [elenco_iban, setElencoIban] = useState([]);
  const navigate = useNavigate();

  const anchorRef = useRef();
  const actionsButton = useRef();
  const [buttonVisible, setButtonVisible] = useState(false);

  const [openDelete, setOpenDelete] = useState(false);

  const [elencoF24, setElencoF24] = useState([]);

  const isAdmin = knowAcces(['admin']);
  const isTL    = knowAcces(['team_leader']);
  const isPaghe = knowAcces(['paghe']);
  const canChangeScope = isTL || (isPaghe && !isAdmin);
  const defaultScope = isTL
    ? 'mine'
    : isAdmin
    ? 'all'
    : isPaghe
    ? 'mine'
    : 'all';
  const [scope, setScope] = useState(defaultScope);
  const scopeButtons = isTL
    ? [['mine', 'Solo miei'], ['team', 'Mio team'], ['all', 'Tutti']]
    : [['mine', 'Solo miei'], ['all', 'Tutti']];
  useEffect(() => { sessionStorage.removeItem('f24_scope'); }, []);

  useEffect(() => {}, [screenSize]);

  const handleToggleButton = () => {
    setButtonVisible(!buttonVisible);
  };

  useEffect(() => {
    loadF24senzaIncarico();
  }, [f24, scope]);

  const loadF24senzaIncarico = async () => {
    if (f24) {
      const responsef24 = await api.get(`/f24/senza_incarico/${f24}`, {
        params: { dataF24: dataF24, scope },
      });

      setElencoF24(responsef24.data);
    }
  };

  const loadModal = async (row) => {
    setSelF24(row);
    await loadReferenti(row);
    await loadIban(row);
    document.getElementById("dettaglioF24senzaincarico").click();
  };
  const loadReferenti = async (row) => {
    const refEst = await api.get(
      `/referenti_aziende_esterno/${row.codice_univoco}`
    );
    setReferentiEsterni(refEst.data.filter((el) => el.tipologia === 3));
  };
  const loadIban = async (row) => {
    const elIb = await api.get(`/iban/${row.codice_univoco}`);
    setElencoIban(elIb.data);
  };

  const handleSave = async (s) => {
    try {
      if (s.giorno_f24) {
        // Update existing record
        const newQuietanzaValue = s.quietanza_disponibile == 1 ? 0 : 1;
        s.quietanza_disponibile = newQuietanzaValue;
        let update = await api.put("/f24", { f24: s });

        // Update only the modified row in local state
        setElencoF24(prevElenco =>
          prevElenco.map(item =>
            item.codice_univoco === s.codice_univoco
              ? { ...item, quietanza_disponibile: newQuietanzaValue }
              : item
          )
        );
      } else {
        // Insert new record
        s.quietanza_disponibile = 1;
        let insert = await api.post("/f24", { f24: s, idF24: f24 });

        // Update only the modified row in local state
        setElencoF24(prevElenco =>
          prevElenco.map(item =>
            item.codice_univoco === s.codice_univoco
              ? { ...item, quietanza_disponibile: 1, giorno_f24: f24 }
              : item
          )
        );
      }
    } catch {
      toast.error("errore durante il salvataggio");
    }
  };

  const columns = [
    {
      field: "inizio_incarico",
      headerName: "Data inizio incarico",
      type: "date",
      flex: 1,
      headerAlign: "center",
      align: "center",
      valueGetter: (params) =>
        params.row.inizio_incarico
          ? new Date(params.row.inizio_incarico)
          : null,
      renderCell: (params) =>
        params.value ? moment(params.value).format("DD/MM/YYYY") : "",
    },
    {
      field: "fine_incarico",
      headerName: "Data fine incarico",
      type: "date",
      flex: 1,
      headerAlign: "center",
      align: "center",
      valueGetter: (params) =>
        params.row.fine_incarico
          ? new Date(params.row.fine_incarico)
          : null,
      renderCell: (params) =>
        params.value ? moment(params.value).format("DD/MM/YYYY") : "",
    },
    {
      field: "codice_univoco",
      headerName: "Codice Univoco",
      width: 100,
      headerAlign: "center",
      align: "center",
    },
    {
      field: "codice_fiscale",
      headerName: "Codice Fiscale",
      width: 100,
      headerAlign: "center",
      align: "center",
    },
    {
      field: "ragione_sociale",
      headerName: "Ragione Sociale",
      flex: 1,
      headerAlign: "center",
      align: "center",
    },
    {
      field: "descrizione_payroll",
      headerName: "Referente",
      flex: 1,
      headerAlign: "center",
      align: "center",
    },
    {
      field: "cassetto_fiscale",
      headerName: "Scadenza Cassetto fiscale",
      type: "date",
      flex: 1,
      headerAlign: "center",
      align: "center",
      valueGetter: (params) =>
        params.row.cassetto_fiscale
          ? new Date(params.row.cassetto_fiscale)
          : null,
      renderCell: (params) =>
        params.value ? moment(params.value).format("DD/MM/YYYY") : "",
    },
    {
      field: "Email",
      headerName: "Email",
      flex: 1,
      headerAlign: "center",
      align: "center",
      renderCell: (params) => {
        if (!params.value) return "";
        return (
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: "6px",
              width: "100%",
            }}
          >
            <span
              style={{
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
              }}
            >
              {params.value}
            </span>
            <button
              type="button"
              title="Copia email"
              onClick={(e) => {
                e.stopPropagation();
                navigator.clipboard
                  .writeText(params.value)
                  .then(() => toast.success("Email copiata"))
                  .catch(() => toast.error("Impossibile copiare l'email"));
              }}
              style={{
                background: "transparent",
                border: "none",
                cursor: "pointer",
                padding: "2px",
                display: "flex",
                alignItems: "center",
              }}
            >
              <MdContentCopy size={16} />
            </button>
          </div>
        );
      },
    },

    {
      field: "quietanza_disponibile",
      headerName: "Quietanza disponibile",
      flex: 1,
      headerAlign: "center",
      align: "center",
      valueGetter: (params) =>
        params.row.quietanza_disponibile === 1 ? "SI" : "NO",
      renderCell: (params) => {
        return (
          <CustomCheckbox
            value={params.row.quietanza_disponibile === 1}
            onClick={() => handleSave(params.row)}
            disabled={!knowAcces(["admin", "f24", "segreteria", "team_leader"])}
          />
        );
      },
    },
  ];

  function CustomToolbar() {
    return (
      <GridToolbarContainer>
        {canChangeScope && (
          <div className="w-full flex flex-wrap gap-x-1 gap-y-1 mb-1">
            {scopeButtons.map(([s, label]) => (
              <button key={s} onClick={() => setScope(s)}
                className={`px-2 py-1 rounded text-xs font-medium border transition-colors ${scope === s ? 'bg-blue-100 border-blue-400 text-blue-700' : 'bg-white border-gray-300 text-gray-600 hover:border-blue-200'}`}>
                {label}
              </button>
            ))}
          </div>
        )}
        <div className="w-full flex flex-wrap-reverse md:flex-nowrap justify-between md:space-x-5 mb-2 gap-y-1">
          <div className="flex md:flex-nowrap md:w-fit w-full flex-wrap justify-center md:justify-start gap-x-2">
            <GridToolbarQuickFilter placeholder="Cerca..." />
          </div>
        </div>
      </GridToolbarContainer>
    );
  }

  return (
    <>
      <ModalF24
        tipologia={"inserimento"}
        idF24={f24}
        self24={self24}
        dataF24={dataF24}
        elenco_iban={elenco_iban}
        referenti_esterni={referenti_esterni}
        setElencoF24={setElencoF24}
      />
      <div className="el-container h-[300px] md:h-[80vh]">
        <DataGridBase
          storageKey="f24_senza_incarico"
          defaultHiddenColumns={{ inizio_incarico: false, fine_incarico: false }}
          slots={{ toolbar: CustomToolbar }}
          initialState={{
            sorting: {
              sortModel: [{ field: 'ragione_sociale', sort: 'asc' }],
            },
          }}
          columns={columns}
          rows={elencoF24}
          getRowId={(r) => r.codice_univoco}
        />
      </div>
    </>
  );
};

const ModalF24 = ({
  idF24,
  tipologia,
  self24,
  dataF24,
  elenco_iban,
  referenti_esterni,
  setElencoF24,
}) => {
  const [open, setOpen] = useState(false);
  const [selectedF24, setSelectedF24] = useState(null);

  const handleClickOpen = async () => {
    console.log(referenti_esterni);
    let s = { ...self24 };

    if (!s.giorno_f24 && elenco_iban.length > 0) {
      s.id_iban = elenco_iban[0].ID;
    }

    setSelectedF24(s);
    setOpen(true);
  };

  const handleChangeCheckbox = (e, name) => {
    let sf24 = { ...selectedF24 };
    sf24[name] = e.target.checked ? 1 : 0;
    setSelectedF24(sf24);
  };

  const handleSave = async () => {
    try {
      if (selectedF24.giorno_f24) {
        let update = await api.put("/f24", { f24: selectedF24 });
        toast.success("f24 modificato con successo");

        // Update only the modified row in local state
        setElencoF24(prevElenco =>
          prevElenco.map(item =>
            item.codice_univoco === selectedF24.codice_univoco
              ? { ...item, ...selectedF24 }
              : item
          )
        );
      } else {
        let insert = await api.post("/f24", { f24: selectedF24, idF24: idF24 });
        toast.success("f24 creato con successo");

        // Update only the modified row in local state
        setElencoF24(prevElenco =>
          prevElenco.map(item =>
            item.codice_univoco === selectedF24.codice_univoco
              ? { ...item, ...selectedF24, giorno_f24: idF24 }
              : item
          )
        );
      }
    } catch {
      toast.error("errore durante il salvataggio");
    }
  };

  return (
    <>
      <Button
        id="dettaglioF24senzaincarico"
        className="hidden"
        text="Aggiungi"
        type="button"
        icon={<HiPlus className="button-icon" />}
        onClick={async () => {
          await handleClickOpen();
        }}
      />

      <Modal
        isOpen={open}
        closeButton={() => setOpen(false)}
        headerText={self24?.ragione_sociale + " - " + dataF24}
        leftButtons={
          <Button
            className="principal-button z-[110]"
            text={tipologia === "elimina" ? "Elimina" : "Salva"}
            type="button"
            icon={<HiOutlineCheck className="button-icon" />}
            onClick={() => handleSave()}
          />
        }
      >
        <div className="grid grid-cols-2 gap-2">
          <div className="col-span-2">
            <CustomCheckbox
              label="quietanza Disponibile"
              name="quietanza_disponibile"
              onClick={(e) => handleChangeCheckbox(e, "quietanza_disponibile")}
              value={selectedF24?.quietanza_disponibile === 1}
            />
          </div>
        </div>
      </Modal>
    </>
  );
};
